import { GET_TABLE, GET_BATCH_HISTORY } from './action'
const INITIAL_STATE = {
  getTable: [],
  getBatchHistory: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_TABLE:
      return {
        ...state,
        getTable: action?.payload,
      }
    case GET_BATCH_HISTORY: {
      return {
        ...state,
        getBatchHistory: action?.payload,
      }
    }

    default:
      return state
  }
}
